export default __webpack_public_path__ + "static/media/012-Tower bridge.f5a9b790.svg";